import { Popup } from "@xp-design/mobile";
import { useImperativeHandle, useMemo, useState } from "react";
import style from "./index.module.less";
import React from "react";
export interface PopupComRef {
  onOpen: () => void;
  onClose: () => void;
}

interface Props {
  children?: React.ReactNode;
  height?: number | string;
  bacUrl?: string;
  title?: string;
  btnStr?: string;
  onCallback?: () => void;
  onCloseCallBack?: () => void;
  isNotAllowedCallBack?: boolean;
}
const PopupCom = React.forwardRef<PopupComRef, Props>((props, ref) => {
  const {
    title,
    height = 544,
    bacUrl = '',
    btnStr,
    onCallback,
    onCloseCallBack,
    isNotAllowedCallBack = false,
  } = props;
  const notStyle = useMemo(() => {
    if (isNotAllowedCallBack) {
      return { background: "rgba(0, 0, 0, 0.25)" };
    } else {
      return {};
    }
  }, [isNotAllowedCallBack]);
  const [visible, setVisible] = useState(false);
  const onClose = () => {
    if (onCloseCallBack) {
      onCloseCallBack();
    }
    console.log('onClose setVisible')
    setVisible(false);
  };
  const onOpen = () => setVisible(true);
  const onSureClick = () => {
    if (!isNotAllowedCallBack) {
      if (onCallback) {
        onCallback();
      }
      onClose();
    }
  };
  const isNumber = (value: number | string) => {
    return typeof value === "number" && !isNaN(value);
  };
  useImperativeHandle(ref, () => ({
    onClose,
    onOpen,
  }));
  return (
    <Popup
      visible={visible}
      showCloseButton
      onMaskClick={() => {
        console.log('onMaskClick')
        onClose();
      }}
      onClose={() => {
        onClose();
      }}
      bodyStyle={{
        height: isNumber(height) ? `${height}rem` : height,
        backgroundImage: `url(${bacUrl}) `, // 设置背景图
        backgroundSize: "100% auto", // 背景图覆盖整个容器
        backgroundRepeat: "no-repeat", // 背景图不重复
        backgroundPosition: "top center", // 背景图居中
      }}
    >
      <div className={style["popupBox"]}>
        {title && <div className={style["title"]}>{title}</div>}
        {props.children}
        {btnStr && (
          <div className={style["btn"]} style={notStyle} onClick={onSureClick}>
            {btnStr}
          </div>
        )}
      </div>
    </Popup>
  );
});

export default PopupCom;
